export const LIST_TRANSACTIONS = 'LIST_TRANSACTIONS';
export const LIST_TRANSACTIONS_SUCCESS = 'LIST_TRANSACTIONS_SUCCESS';
export const LIST_TRANSACTIONS_FAILED = 'LIST_TRANSACTIONS_FAILED';
